module.exports = __webpack_public_path__ + "img/logo_login.0ec0b09e.png";